import { useFormikContext } from "formik";
import { Users } from "lucide-react";
import { PlateformeFormFieldNames } from "../form/PlateformeFormFieldNames";
import { PlateformeFormValues } from "../form/PlateformeFormValues";
import { CORPORATE_ROLE_OPTIONS } from "../form/plateformeRoles";
import { CreateSectionCard } from "./CreateSectionCard";

export const PlateformeRolesSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<PlateformeFormValues>();
  const selected = values[PlateformeFormFieldNames.AdditionalRoles] ?? [];

  const toggleRole = (role: string) => {
    const next = selected.includes(role)
      ? selected.filter((r) => r !== role)
      : [...selected, role];
    setFieldValue(PlateformeFormFieldNames.AdditionalRoles, next);
  };

  return (
    <CreateSectionCard
      id="section-roles"
      icon={Users}
      title="Rôles"
      subtitle="Sélectionnez les capacités de la société."
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {CORPORATE_ROLE_OPTIONS.map((option) => (
          <label
            key={option.value}
            className="flex items-start gap-3 rounded-xl border border-gray-200 bg-white p-4 cursor-pointer shadow-sm hover:border-primary/40 transition-colors"
          >
            <input
              type="checkbox"
              checked={selected.includes(option.value)}
              onChange={() => toggleRole(option.value)}
              className="mt-0.5 h-5 w-5 rounded-md border-gray-300 text-primary focus:ring-primary"
            />
            <span className="flex flex-col gap-0.5">
              <span className="text-sm font-semibold text-gray-900">{option.label}</span>
              <span className="text-xs text-gray-500 leading-relaxed">{option.description}</span>
            </span>
          </label>
        ))}
      </div>
      <p className="mt-4 text-xs text-gray-500">
        Les rôles <span className="font-semibold">Plateforme</span> et{' '}
        <span className="font-semibold">Assureur</span> sont attribués automatiquement :
        la société est sélectionnable comme assureur dans la configuration des tunnels.
      </p>
    </CreateSectionCard>
  );
};
